<template>
  <div class="field">
    <h2 class="field-title">{{ title }}</h2>
    <wysiwyg
      readonly
      dense
      :value="description"
      hide-toolbar
      borderless
      content-class="p-0"
    />
    <p class="text-sm">
      <strong>{{ $t('brand-offer-details-view.cost-center') }}</strong>
      {{ centralCostName }}
    </p>
    <p v-if="startDateLabel && startDateFormatted" class="text-sm mt-1">
      <strong>{{ startDateLabel }}</strong>
      {{ startDateFormatted }}
      <template v-if="shouldShowEndDate && endDateFormatted">
        – {{ endDateFormatted }}
      </template>
    </p>
    <p v-if="isIndefinite !== null" class="text-sm mt-1">
      <strong>
        {{
          isIndefinite
            ? $t('brand-offer-details-view.indefinite-offer')
            : $t('brand-offer-details-view.definite-offer')
        }}
      </strong>
    </p>
  </div>
</template>
<script>
import Wysiwyg from '@/components/WysiwygInput/WysiwygInput.vue';
import { format } from 'date-fns';
import { useHalfToDate } from '@/util/half-to-date';

export default {
  components: { Wysiwyg },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    centralCostName: {
      type: String,
      default: '',
    },
    isIndefinite: {
      type: Boolean,
      default: null,
    },
    startDate: {
      type: [String, Date],
    },
    endDate: {
      type: [String, Date],
    },
  },
  computed: {
    startDateValue() {
      if (typeof this.startDate !== 'string') return null;
      return useHalfToDate(this.startDate, false);
    },
    endDateValue() {
      if (typeof this.endDate !== 'string') return null;
      return useHalfToDate(this.endDate, true);
    },
    shouldShowEndDate() {
      return this.isIndefinite !== true;
    },
    startDateLabel() {
      if (!this.startDateValue) return null;
      return this.isIndefinite === true
        ? this.$t('brand-offer-details-view.start-date')
        : this.$t('brand-offer-details-view.period');
    },
    startDateFormatted() {
      if (!this.startDateValue) return null;
      return format(this.startDateValue, 'dd/MM/yyyy');
    },
    endDateFormatted() {
      if (!this.endDateValue) return null;
      return format(this.endDateValue, 'dd/MM/yyyy');
    },
  },
};
</script>
<style scoped lang="scss">
.field {
  @apply bg-white rounded-md p-3.5 mt-4;

  &-title {
    @apply text-header pb-1 font-semibold;
  }

  &-description {
    @apply text-sm;
  }
}
</style>
